var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accountDetection"},[_c('div',{staticClass:"tab_list"},[_c('sky-tabs',{attrs:{"tabList":_vm.tabList},model:{value:(_vm.tabValue),callback:function ($$v) {_vm.tabValue=$$v},expression:"tabValue"}})],1),_c('div',{staticClass:"tab_body"},[_c(_vm.tabValue,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }